import { useContext, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import ModalFooterMobile from '@wix/da-ds/pkg/modals/dsPresets/ModalFooterMobile';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import PayPalAccountBlock from '../PayPalWithdrawAmountModal/_partials/PayPalAccountBlock';
import PayPalPaymentTerms from '../../_partials/PayPalPaymentTerms';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import s from './PayPalWithdrawConfirmationModal.scss';

export interface Props {
  isOpen: boolean;
  requestClose: () => void;
  paypalEmail?: string;
  onDone?: () => void;
}

const PayPalWithdrawConfirmationModal: FC<Props> = ({
  isOpen,
  requestClose,
  paypalEmail = 'example@gmail.com',
  onDone,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const handleDone = () => {
    onDone?.();
    requestClose();
  };

  return (
    <Modal
      className={s['wrapper']}
      contentClassName={s['content']}
      heading={t('studio.earnings.withdrawToPayPal.confirmation.title')}
      onRequestClose={requestClose}
      showHeaderBorder
      showFooterBorder
      shouldCloseOnOverlayClick
      isOpen={isOpen}
      withScrollableContentWrapper
      footerRight={[
        <BrandedButton
          onClick={handleDone}
          size="large"
          variant="brand-green"
          key="done"
        >
          {t('common.gotIt')}
        </BrandedButton>,
      ]}
      footerPadding={isMobile ? 'none' : undefined}
      footer={
        isMobile ? (
          <ModalFooterMobile
            primaryButton={
              <BrandedButton
                fillContainerWidth={true}
                onClick={handleDone}
                size="large"
                variant="brand-green"
                key="done"
              >
                {t('common.gotIt')}
              </BrandedButton>
            }
          />
        ) : undefined
      }
    >
      <div className={s['subtitle']}>
        {t('studio.earnings.withdrawToPayPal.confirmation.subtitle')}
      </div>

      <div className={s['description']}>
        {t('studio.earnings.withdrawToPayPal.confirmation.description')}
      </div>

      <PayPalAccountBlock
        paypalEmail={paypalEmail}
        className={s['account-block']}
      />

      <PayPalPaymentTerms className={s['terms-block']} />
    </Modal>
  );
};

PayPalWithdrawConfirmationModal.displayName = 'PayPalWithdrawConfirmationModal';

export default PayPalWithdrawConfirmationModal;
